module.exports = __webpack_public_path__ + "img/apple-pay.0ddd6bef.svg";